import { render, staticRenderFns } from "./BlockDefault.vue?vue&type=template&id=83be95ee"
import script from "./BlockDefault.vue?vue&type=script&lang=js"
export * from "./BlockDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports